// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const gtag = (...args: any[]) => {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag(...args);
  }
};
